import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var Server04 = function Server04(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "m22 10.5-.4744-3.7954c-.1861-1.4886-.2791-2.233-.6295-2.7938A3 3 0 0 0 19.613 2.778c-.6-.278-1.3501-.278-2.8504-.278H7.2374c-1.5003 0-2.2504 0-2.8504.278a3 3 0 0 0-1.283 1.1328c-.3504.5609-.4434 1.3052-.6295 2.7938L2 10.5m3.5 4h13m-13 0C3.567 14.5 2 12.933 2 11s1.567-3.5 3.5-3.5h13c1.933 0 3.5 1.567 3.5 3.5s-1.567 3.5-3.5 3.5m-13 0C3.567 14.5 2 16.067 2 18s1.567 3.5 3.5 3.5h13c1.933 0 3.5-1.567 3.5-3.5s-1.567-3.5-3.5-3.5M6 11h.01M6 18h.01M12 11h6m-6 7h6"
    })
  }));
};
export default Server04;